(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return componentTabs$1; }), Promise.resolve().then(function () { return componentProductXyz3d$1; }), Promise.resolve().then(function () { return fragmentProductHeroInfo$1; }), Promise.resolve().then(function () { return fragmentBuyBar$1; }), Promise.resolve().then(function () { return fragmentProductDetailList$1; }), Promise.resolve().then(function () { return cappasity$1; })];
        const componentsObj = hydrateComponents(components);
        await componentsObj.hydrate?.();
      })();
    });

    const {
      getElementsByRef: getElementsByRef$3
    } = window.PoleneLibs.Refs;
    class ComponentTabs extends HTMLElement {
      tabs = [];
      panels = [];
      activePanel = undefined;
      activeTab = undefined;
      isLastInFocusTrap = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
        this.setupAccessibility();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        const {
          tab,
          tabPanel
        } = getElementsByRef$3(['tab', 'tab-panel'], this);
        if (!tab || !tabPanel) return;
        this.tabs = Array.isArray(tab) ? tab : [tab];
        this.panels = Array.isArray(tabPanel) ? tabPanel : [tabPanel];
        this.activeTab = this.tabs.find(trigger => trigger?.classList.contains('active'));
        this.activePanel = this.panels.find(panel => panel?.classList.contains('active') && this.activeTab?.dataset.panelId === panel.id);
        this.isLastInFocusTrap = this.dataset.isLastInFocusTrap === 'true';
      };
      setupEventListeners = () => {
        this.tabs.forEach(tab => tab?.addEventListener('click', this.handleClick));
      };
      removeEventListeners = () => {
        this.tabs.forEach(tab => tab?.removeEventListener('click', this.handleClick));
      };
      setupAccessibility = () => {
        this.panels.forEach(panel => {
          if (panel) {
            panel.tabIndex = panel.classList.contains('active') ? 0 : -1;
          }
        });
        if (this.isLastInFocusTrap) {
          this.panels.forEach(panel => {
            if (panel && panel.lastElementChild) panel.lastElementChild.setAttribute('data-is-last-focus', 'true');
          });
        }
      };
      handleClick = event => {
        const triggeredTab = event.currentTarget;
        const {
          panelId
        } = triggeredTab.dataset;
        if (triggeredTab === this.activeTab) return;
        this.switchTab(triggeredTab);
        if (panelId) this.switchPanel(panelId);
      };
      switchTab = targetTab => {
        if (this.activeTab) {
          this.activeTab.classList.remove('active');
          this.activeTab.ariaSelected = 'false';
        }
        if (!targetTab.classList.contains('active')) {
          targetTab.classList.add('active');
          targetTab.ariaSelected = 'true';
        }
        this.activeTab = targetTab;
      };
      switchPanel = targetPanelId => {
        const newActivePanel = this.panels.find(panel => targetPanelId === panel?.id);
        if (this.activePanel) {
          this.activePanel.classList.remove('active');
          this.activePanel.ariaHidden = 'true';
          this.activePanel.tabIndex = -1;
        }
        if (newActivePanel && !newActivePanel.classList.contains('active')) {
          newActivePanel.classList.add('active');
          newActivePanel.ariaHidden = 'false';
          newActivePanel.tabIndex = 0;
          this.activePanel = newActivePanel;
        }
      };
      static define = () => {
        if (!customElements.get('component-tabs')) {
          customElements.define('component-tabs', ComponentTabs);
        }
      };
    }
    var componentTabs = () => {
      ComponentTabs.define();
    };

    var componentTabs$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentTabs: ComponentTabs,
        default: componentTabs
    });

    const {
      buildPowerXyzUrl
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$1
    } = window.PoleneLibs.Refs;
    const {
      isMobile
    } = window.PoleneLibs.Utils;
    class ProductXYZ3D extends HTMLElement {
      controller = undefined;
      trigger = null;
      mainViewer = null;
      secondaryViewer = null;
      packshotContainer = null;
      isPackshot = this.dataset?.isPackshot === 'true' || false;
      viewerButtons = null;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      initializeElements = async () => {
        const xyzViewer = this.querySelector('[data-ref="xyz-viewer"]');
        const xyzViewerInside = this.querySelector('[data-ref="xyz-viewer-inside"]');
        const viewerButtons = this.querySelector('[data-ref="viewer-buttons"]');
        const packshotContainerSelector = isMobile() ? '.product-packshot__container' : '.product-packshot__container-desktop';
        this.packshotContainer = document.querySelector(packshotContainerSelector);
        if (!this.packshotContainer) return;
        if (viewerButtons) {
          this.viewerButtons = viewerButtons;
        }
        if (this.dataset.insideTrigger) {
          const xyzTriggerViewInside = document.querySelector(`[data-ref='${this.dataset.insideTrigger}']`);
          if (xyzTriggerViewInside) {
            this.trigger = xyzTriggerViewInside;
          }
        }
        if (!this.dataset.isEnabled) {
          this.destroy();
        }
        if (xyzViewerInside) {
          this.secondaryViewer = xyzViewerInside;
          const is3dAvailable = await this.check3DAvailability(this.secondaryViewer.getAttribute('company-eid') || '', this.secondaryViewer.getAttribute('sku') || '');
          if (!is3dAvailable) {
            this.secondaryViewer.remove();
            this.secondaryViewer = null;
          }
        }
        if (xyzViewer) {
          this.mainViewer = xyzViewer;
          const is3dAvailable = await this.check3DAvailability(this.mainViewer.getAttribute('company-eid') || '', this.mainViewer.getAttribute('sku') || '');
          if (is3dAvailable) {
            if (this.isPackshot) {
              this.toggleViewer();
            }
            this.setupEventListeners();
          } else {
            this.destroy();
          }
        }
      };
      destroy = () => {
        const viewerContainer = this.querySelector('[data-ref="xyz-viewer-container"]');
        if (viewerContainer) {
          viewerContainer.remove();
        }
      };
      setupEventListeners = () => {
        if (this.trigger) {
          this.trigger?.addEventListener('click', this.handleTriggerClick, {
            signal: this.controller?.signal
          });
        }
      };
      handleTriggerClick = () => {
        if (this.mainViewer && this.trigger && this.secondaryViewer) {
          const {
            activeLabel,
            inactiveLabel
          } = getElementByRef$1(['active-label', 'inactive-label'], this.trigger);
          activeLabel?.classList.toggle('is-hidden');
          inactiveLabel?.classList.toggle('is-hidden');
          this.mainViewer.classList.toggle('is-hidden');
          this.secondaryViewer.classList.toggle('is-hidden');
        }
      };
      check3DAvailability = async (companyEid, SKU) => {
        const url = buildPowerXyzUrl(companyEid, SKU);
        if (!url) return false;
        try {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return true;
        } catch (error) {
          return false;
        }
      };
      toggleViewer = () => {
        this.mainViewer?.classList.toggle('is-hidden');
        if (this.viewerButtons) {
          this.viewerButtons.classList.toggle('is-hidden');
        }
        if (this.trigger && this.secondaryViewer) {
          this.trigger.classList.remove('is-hidden');
        }
        if (this.isPackshot && this.packshotContainer) {
          if (this.viewerButtons) {
            if (isMobile()) {
              const galleryButton = this.packshotContainer.querySelector('.power-xyz-3d-viewer-container > button');
              if (galleryButton) {
                galleryButton.setAttribute('disabled', 'true');
              }
            } else {
              this.packshotContainer.setAttribute('disabled', 'true');
            }
          }
          this.querySelector('img.packshot-img')?.remove();
        }
        const zoomableImage = this.querySelector('.component-zoomable-image');
        if (zoomableImage) {
          zoomableImage.remove();
        }
      };
      static define = () => {
        if (!customElements.get('product-xyz-3d')) {
          customElements.define('product-xyz-3d', ProductXYZ3D);
        }
      };
    }
    var componentProductXyz3d = () => {
      ProductXYZ3D.define();
    };

    var componentProductXyz3d$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ProductXYZ3D: ProductXYZ3D,
        default: componentProductXyz3d
    });

    const {
      wrappedLoader
    } = window.PoleneLibs.ElementTemplates;
    const events$2 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$2,
      parseProductForm
    } = window.PoleneLibs.Utils;
    const {
      getRefs: getRefs$1
    } = window.PoleneLibs.Refs;
    const {
      morphSection
    } = window.PoleneLibs.SectionRenderer;
    const root = window.Shopify?.routes.root;
    const selectors$2 = {
      cartCounter: '.js-cart-counter',
      variantInput: '.js-variant-input'
    };
    const added_to_cart = window.translations?.added_to_cart || 'Added to cart';
    const updateCartContent = async section => {
      try {
        const cartComponent = document.querySelector('component-cart-items');
        const sectionId = cartComponent?.getAttribute('data-section-id') || 'main-cart';
        await morphSection(sectionId, section);
        dispatchEvent$2(window, events$2.CART_UPDATED);
        dispatchEvent$2(window, events$2.CART_DOM_UPDATED);
      } catch (error) {
        const {
          cart
        } = getRefs$1();
        if (cart) {
          cart.innerHTML = section;
          setCartCount(0);
        }
      }
    };
    const setCartCount = amount => {
      const counters = document.querySelectorAll(selectors$2.cartCounter);
      counters.forEach(counter => {
        const currentText = counter.innerHTML;
        const newText = counter.classList.contains('visually-hidden') ? currentText.replace(/\d+/, amount.toString()) : amount.toString();
        counter.innerHTML = newText;
      });
    };
    const triggeredProductForm = {};
    const handleAddToCart = async productForm => {
      const forms = productForm.getElementsByTagName('form');
      const form = forms[0];
      const formData = new FormData(form);
      const items = parseProductForm(formData);
      const btns = form.getElementsByTagName('button');
      const inputs = form.getElementsByTagName('input');
      const submitBtn = btns[0];
      const defaultSubmitBtnState = submitBtn.dataset.defaultState;
      let preOrderBtn = false;
      let preOrderLabel = '';
      let eContainer;
      const states = {
        success: 'success',
        loading: 'loading',
        default: 'default',
        disabled: 'disabled'
      };
      if (submitBtn.dataset.state == states.disabled) {
        let variantId = null;
        if (!items.length) {
          variantId = form.querySelectorAll(selectors$2.variantInput)[0].value;
        } else {
          variantId = items[0].id;
          const hasOptions = form.getElementsByTagName('option');
          if (hasOptions && items[0].id === '0') {
            variantId = form.getElementsByTagName('option')[1].value;
          }
        }
        dispatchEvent$2(window, events$2.TOGGLE_BIS, {
          variantId
        });
        return;
      }
      if (productForm.nextElementSibling) {
        const {
          errorContainer
        } = getRefs$1(productForm.nextElementSibling);
        eContainer = errorContainer;
      }
      if (!submitBtn.firstElementChild) {
        preOrderBtn = true;
        preOrderLabel = submitBtn.innerHTML;
        submitBtn.innerHTML = wrappedLoader;
      }
      submitBtn.dataset.state = states.loading;
      const cartComponent = document.querySelector('component-cart-items');
      const sectionId = cartComponent?.getAttribute('data-section-id') || 'main-cart';
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items,
            sections: `${sectionId},cart-notification-product`
          })
        });
        const json = await response.json();
        if (response.ok) {
          if (cartComponent && json.sections && json.sections[sectionId]) {
            await updateCartContent(json.sections[sectionId]);
          }
          dispatchEvent$2(window, events$2.CART_UPDATED, json);
          submitBtn.dataset.state = states.success;
          if (eContainer && eContainer.innerHTML) eContainer.innerHTML = '';
          if (preOrderBtn) submitBtn.innerHTML = added_to_cart;
          if (productForm.dataset.handle in triggeredProductForm) {
            clearTimeout(triggeredProductForm[productForm.dataset.handle]);
            delete triggeredProductForm[productForm.dataset.handle];
          }
          triggeredProductForm[productForm.dataset.handle] = setTimeout(() => {
            submitBtn.dataset.state = defaultSubmitBtnState;
            [...inputs].forEach(input => {
              input.checked = false;
            });
            if (preOrderBtn) {
              submitBtn.innerHTML = preOrderLabel;
            }
            clearTimeout(triggeredProductForm[productForm.dataset.handle]);
            delete triggeredProductForm[productForm.dataset.handle];
          }, 3000);
        } else {
          submitBtn.dataset.state = defaultSubmitBtnState;
          if (eContainer) {
            eContainer.innerHTML = json.description;
            setTimeout(() => {
              eContainer.innerHTML = '';
            }, 5000);
          }
        }
      } catch (error) {
        submitBtn.dataset.state = defaultSubmitBtnState;
      }
    };

    const {
      breakpoints: breakpoints$1
    } = window.PoleneLibs.Breakpoints;
    const {
      intersection
    } = window.PoleneLibs.Observer;
    const {
      getElementsByRef: getElementsByRef$2
    } = window.PoleneLibs.Refs;
    let scrolledPassed = false;
    const classes$1 = {
      showBuyBar: 'buy-bar-visible',
      isPreOrder: 'is-preorder',
      titleVisible: 'title-visible'
    };
    const selectors$1 = {
      productForm: '.js-product-form'
    };
    var fragmentProductHeroInfo = async () => {
      const {
        productDetails,
        productForm,
        stickyContainer
      } = getElementsByRef$2(['product-details', 'product-form', 'sticky-container']);
      if (!productDetails || !productForm) return;
      let observer;
      let isMobile = true;
      const forms = Array.isArray(productForm) ? [...productForm] : [];
      const init = () => {
        setScreenSize();
        setEventListeners();
        observer = intersection(productDetails, handleIntersection, {
          threshold: [0]
        });
      };
      const setScreenSize = () => {
        isMobile = window.innerWidth < breakpoints$1.md;
      };
      const setEventListeners = () => {
        forms.forEach(form => form.addEventListener('submit', addToCart));
        window.addEventListener('scroll', handleScroll);
      };
      const handleScroll = () => {
        if (!isMobile || !stickyContainer) return;
        stickyContainer.classList.toggle(classes$1.titleVisible, window.scrollY > window.innerHeight * 0.7);
      };
      const addToCart = async e => {
        e.preventDefault();
        const productForm = e.target.closest(selectors$1.productForm);
        handleAddToCart(productForm);
      };
      const handleIntersection = ([entry]) => {
        if (isMobile) return;
        if (entry.isIntersecting) {
          scrolledPassed = true;
          document.body.classList.remove(classes$1.showBuyBar);
        } else {
          if (scrolledPassed) {
            document.body.classList.add(classes$1.showBuyBar);
            scrolledPassed = false;
          }
        }
      };
      setTimeout(() => {
        init();
      });
      return () => {
        observer.unobserve(productDetails);
        forms.forEach(form => form.removeEventListener('submit', addToCart));
        window.removeEventListener('scroll', handleScroll);
      };
    };

    var fragmentProductHeroInfo$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentProductHeroInfo
    });

    const events$1 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$1,
      scrollToPosition
    } = window.PoleneLibs.Utils;
    const {
      getElementsByRef: getElementsByRef$1,
      getRefs
    } = window.PoleneLibs.Refs;
    var fragmentBuyBar = () => {
      const {
        buyBar,
        addToCartBtn
      } = getElementsByRef$1(['buy-bar', 'add-to-cart-btn']);
      if (!buyBar || !addToCartBtn) return;
      const {
        toTopTrigger,
        optionsClose
      } = getRefs(buyBar);
      const init = () => {
        if (optionsClose) {
          optionsClose.addEventListener('click', handleClose);
        }
        toTopTrigger.addEventListener('click', handleClick);
      };
      const handleClick = e => {
        e.preventDefault();
        scrollToPosition(0, 1000, () => {
          if (Array.isArray(addToCartBtn)) addToCartBtn.forEach(btn => btn.focus());else addToCartBtn.focus();
        });
      };
      const handleClose = () => {
        dispatchEvent$1(window, events$1.CLOSE_OPTIONS);
      };
      init();
      return () => {
        if (optionsClose) {
          optionsClose.removeEventListener('click', handleClose);
        }
        toTopTrigger.removeEventListener('click', handleClick);
      };
    };

    var fragmentBuyBar$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentBuyBar
    });

    const {
      breakpoints
    } = window.PoleneLibs.Breakpoints;
    const events = window.PoleneLibs.Events.default;
    const scrollLock = window.PoleneLibs.ScrollLock.default;
    const {
      dispatchEvent
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef,
      getElementsByRef
    } = window.PoleneLibs.Refs;
    const selectors = {
      item: '.js-item',
      toggle: '.js-toggle',
      contentItems: '.js-content',
      threeSixty: '.js-threesixty',
      fullscreen: '.js-fullscreen',
      colorOptions: '.js-color-option'
    };
    const classes = {
      active: 'is-active',
      hidden: 'is-hidden',
      visible: 'is-visible',
      added: 'is-added',
      colorOption: 'js-color-option',
      fullscreen: 'is-fullscreen',
      isOverflow: 'is-overflow'
    };
    let currentContent = null;
    let cursorState = 'default';
    let fullscreenMode = false;
    var fragmentProductDetailList = async () => {
      const {
        cappasityTrigger
      } = getElementsByRef(['cappasity-trigger']);
      const {
        productDetails,
        productTitle,
        optionsClose,
        stickyContainer,
        backCta,
        buyBar
      } = getElementByRef(['product-details', 'product-title', 'options-close', 'sticky-container', 'back-cta', 'buy-bar']);
      if (!productDetails) return;
      const {
        toggleList,
        swapContainer,
        optionToggle
      } = getElementByRef(['toggle-list', 'swap-container', 'option-toggle', 'option-container', 'option-scroll-container', 'navigate-left', 'navigate-right'], productDetails);
      const {
        contentItems,
        toggles,
        accordionItems,
        imgView
      } = getElementsByRef(['content-items', 'toggles', 'accordion-items', 'img-view'], productDetails);
      const items = Array.isArray(contentItems) ? contentItems : [contentItems];
      const toggleItems = Array.isArray(toggles) ? toggles : [toggles];
      const accordions = Array.isArray(accordionItems) ? accordionItems : [accordionItems];
      const triggers = Array.isArray(cappasityTrigger) ? cappasityTrigger : [cappasityTrigger];
      const init = () => {
        setEventListeners();
      };
      const setEventListeners = () => {
        toggleList?.addEventListener('click', handleToggleClick);
        toggleList?.addEventListener('keydown', event => {
          if (event.key === 'Enter') {
            handleToggleClick(event);
          }
        });
        swapContainer?.addEventListener('click', handleContainerClick);
        swapContainer?.addEventListener('mouseenter', handleMouseOver);
        swapContainer?.addEventListener('mouseleave', handleMouseLeave);
        swapContainer?.addEventListener('keydown', event => {
          if (event.key === 'Enter') {
            handleContainerClick(event);
          }
        });
        triggers.forEach(trigger => {
          trigger?.addEventListener('click', handleTriggerClick);
          trigger?.addEventListener('keydown', event => {
            if (event.key === 'Enter') {
              handleTriggerClick();
            }
          });
        });
        if (Array.isArray(items)) {
          items?.forEach(item => {
            item?.firstElementChild?.addEventListener('mouseenter', handleMouseLeave);
            item?.firstElementChild?.addEventListener('mouseleave', handleMouseOver);
          });
        }
        window.addEventListener(events.CLOSE_OPTIONS, closeOptions);
      };
      const setToggleAriaState = ({
        item,
        value
      }) => {
        item.setAttribute('aria-expanded', value.toString());
        item.setAttribute('aria-current', value.toString());
      };
      const handleMouseOver = () => {
        dispatchEvent(window, events.CHANGE_CURSOR, {
          type: cursorState,
          contrast: false
        });
      };
      const handleMouseLeave = () => {
        if (cursorState === 'default') return;
        dispatchEvent(window, events.CHANGE_CURSOR, {
          type: 'default',
          contrast: false
        });
      };
      const closeOptions = () => {
        currentContent = null;
        items?.forEach(item => {
          if (item?.dataset.itemContent == 'img') {
            item?.classList.add(classes.visible);
          } else {
            item?.classList.remove(classes.visible);
          }
        });
        toggleItems?.forEach(toggle => toggle?.classList.remove(classes.active));
        if (optionToggle) {
          optionToggle.classList.remove(classes.active);
        }
        scrollLock(false);
        handleColorOptions(false);
      };
      const handleColorOptions = closeOptions => {
        if (!swapContainer) return;
        if (closeOptions) {
          productTitle?.classList.add(classes.hidden);
          optionsClose?.classList.remove(classes.hidden);
          swapContainer.style.overflowY = 'scroll';
        } else {
          productTitle?.classList.remove(classes.hidden);
          optionsClose?.classList.add(classes.hidden);
          swapContainer.style.overflowY = 'hidden';
        }
      };
      const handleTriggerClick = () => {
        const isMobile = window.innerWidth < breakpoints.md;
        if (!isMobile) return;
        handleImgView();
        if (!imgView) return;
        const views = Array.isArray(imgView) ? imgView : [imgView];
        fullscreenMode = !fullscreenMode;
        scrollLock(fullscreenMode);
        if (stickyContainer || backCta) {
          if (stickyContainer && backCta && buyBar) {
            buyBar.style.display = fullscreenMode ? 'none' : 'flex';
            backCta.style.display = fullscreenMode ? 'none' : 'flex';
            stickyContainer.style.display = fullscreenMode ? 'none' : 'flex';
          }
        }
        views.forEach(view => {
          view.classList.toggle(classes.fullscreen);
        });
      };
      const handleToggleClick = e => {
        const item = e.target.closest(selectors.item);
        const colorToggle = e.target.closest(selectors.toggle);
        const content = item ? item.dataset.item : 'options';
        if (content === currentContent) {
          if (item) {
            setToggleAriaState({
              item: item,
              value: false
            });
          }
          resetContent();
          return;
        }
        currentContent = content;
        cursorState = 'close';
        setVisibleContent(content);
        if (item) {
          let ariaBoolean = true;
          toggleItems.forEach(toggle => {
            if (toggle == item) {
              toggle?.classList.add(classes.active);
              ariaBoolean = true;
            } else {
              toggle?.classList.remove(classes.active);
              optionToggle?.classList.remove(classes.active);
              ariaBoolean = false;
            }
            if (toggle) setToggleAriaState({
              item: toggle,
              value: ariaBoolean
            });
          });
        }
        if (colorToggle) {
          toggleItems.forEach(toggle => toggle?.classList.remove(classes.active));
          optionToggle?.classList.add(classes.active);
          if (swapContainer) swapContainer.style.overflowY = 'scroll';
          scrollLock(true);
        }
      };
      const resetContent = () => {
        currentContent = null;
        cursorState = 'default';
        if (swapContainer) swapContainer.style.overflowY = 'hidden';
        scrollLock(false);
        dispatchEvent(window, events.CHANGE_CURSOR, {
          type: 'default',
          contrast: false
        });
        setVisibleContent('img');
        toggleItems.forEach(toggle => toggle?.classList.remove(classes.active));
        if (optionToggle) {
          optionToggle.classList.remove(classes.active);
        }
      };
      const handleContainerClick = e => {
        const btn = e.target.closest(selectors.threeSixty);
        const fullscreen = e.target.closest(selectors.fullscreen);
        if (fullscreen) {
          if (!imgView) return;
          const views = Array.isArray(imgView) ? imgView : [imgView];
          const isMobile = window.innerWidth < breakpoints.md;
          fullscreenMode = !fullscreenMode;
          scrollLock(fullscreenMode);
          if (isMobile) {
            if (stickyContainer || backCta) {
              if (buyBar && backCta && stickyContainer) {
                buyBar.style.display = fullscreenMode ? 'none' : 'flex';
                backCta.style.display = fullscreenMode ? 'none' : 'flex';
                stickyContainer.style.display = fullscreenMode ? 'none' : 'flex';
              }
            }
          }
          views.forEach(view => {
            view.classList.toggle(classes.fullscreen);
          });
        }
        if (btn) {
          handleImgView();
          if (btn.classList.contains(classes.active)) {
            btn.classList.remove(classes.active);
          } else {
            btn.classList.add(classes.active);
          }
        }
        if (e.target.classList && e.target.classList.contains(classes.colorOption) || currentContent === 'img' || currentContent === null) return;
        resetContent();
      };
      const handleImgView = () => {
        if (!imgView) return;
        const views = Array.isArray(imgView) ? imgView : [imgView];
        views.forEach(view => {
          view.classList.toggle(classes.visible);
        });
      };
      const handleShowOptions = () => {
        if (productTitle && optionsClose) {
          handleColorOptions(true);
        }
        const optionContainer = items.find(item => item?.dataset.itemContent === 'options');
        optionContainer?.classList.add(classes.visible);
        scrollLock(true);
      };
      const handleToggleAccordion = content => {
        accordions?.forEach(item => {
          if (!item) return;
          if (item?.dataset.itemContent == content) {
            const height = item?.style.maxHeight == item?.scrollHeight + 'px' ? '0px' : item?.scrollHeight + 'px';
            if (height === '0px') {
              const toggle = toggleItems.find(toggle => toggle?.dataset.item === content);
              toggle?.classList.remove(classes.active);
            }
            item.style.maxHeight = height;
          } else {
            item.style.maxHeight = '0px';
          }
        });
      };
      const handleFocusOut = elementId => {
        if (!elementId) return;
        const element = document.querySelector(`[aria-controls="${elementId}"]`);
        element?.setAttribute('aria-hidden', 'true');
        element?.focus();
      };
      const setVisibleContent = content => {
        const isMobile = window.innerWidth < breakpoints.md;
        if (isMobile) {
          if (content === 'options') {
            handleShowOptions();
            scrollLock(true);
          } else {
            handleToggleAccordion(content);
          }
        } else {
          items.forEach(item => {
            const contentToFocus = item?.querySelector('.content');
            if (item?.dataset.itemContent == content) {
              item?.classList.add(classes.visible);
              contentToFocus?.setAttribute('aria-hidden', 'false');
              const childWithAriaHidden = contentToFocus?.querySelectorAll('[aria-hidden]');
              childWithAriaHidden?.forEach(child => {
                child?.setAttribute('aria-hidden', 'false');
                child.setAttribute('tabindex', '0');
              });
              contentToFocus?.addEventListener('focusout', event => {
                const eventTarget = event.relatedTarget;
                if (!eventTarget || !contentToFocus.contains(eventTarget)) {
                  childWithAriaHidden?.forEach(child => {
                    child?.setAttribute('aria-hidden', 'true');
                    child.setAttribute('tabindex', '-1');
                  });
                  handleFocusOut(contentToFocus?.getAttribute('id') || undefined);
                }
              });
              contentToFocus?.focus();
            } else {
              item?.classList.remove(classes.visible);
              contentToFocus?.removeEventListener('focusout', () => handleFocusOut);
            }
          });
        }
      };
      setTimeout(() => {
        init();
      });
      return () => {
        optionToggle?.removeEventListener('click', handleToggleClick);
        optionToggle?.removeEventListener('click', handleToggleClick);
        toggleList?.removeEventListener('click', handleToggleClick);
        toggleList?.removeEventListener('keydown', event => {
          if (event.key === 'Enter') {
            handleToggleClick(event);
          }
        });
        swapContainer?.removeEventListener('click', handleContainerClick);
        swapContainer?.removeEventListener('keydown', event => {
          if (event.key === 'Enter') {
            handleContainerClick(event);
          }
        });
        swapContainer?.removeEventListener('mouseenter', handleMouseOver);
        swapContainer?.removeEventListener('mouseleave', handleMouseLeave);
      };
    };

    var fragmentProductDetailList$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentProductDetailList
    });

    var cappasity = () => {
      const {
        getElementsByRef
      } = window.PoleneLibs.Refs;
      const {
        cappasity,
        cappasityTrigger
      } = getElementsByRef(['cappasity', 'cappasity-trigger']);
      if (!cappasity || !cappasityTrigger) return;
      const triggers = Array.isArray(cappasityTrigger) ? [...cappasityTrigger] : [cappasityTrigger];
      let isAppended = false;
      const elements = Array.isArray(cappasity) ? [...cappasity] : [cappasity];
      const AUTO_RESIZE = true;
      const REMOVE_TRIGGER_ON_ERROR = true;
      elements.map(async (element, index) => {
        try {
          const response = await fetch(`/apps/cappasity/embed-list?productId=${element.dataset.id}`);
          if (!response.ok) {
            throw '404 - Could not load Cappasity api script';
          }
          const json = await response.json();
          if (!json.length) {
            if (REMOVE_TRIGGER_ON_ERROR) {
              cappasityTrigger[index].remove();
            }
            throw '404 - Could not load 3d-view for: ' + element.dataset.id;
          }
          const playerHTML = json[0].playerHTML;
          const iframe = AUTO_RESIZE ? playerHTML.replace('height="600"', 'height="100%"').replace("height='600'", 'height="100%"').replace('hidesettingsbtn=0', 'hidesettingsbtn=1').replace('hidefullscreen=0', 'hidefullscreen=1') : playerHTML;
          triggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
              if (!isAppended) {
                element.insertAdjacentHTML('afterbegin', iframe);
                isAppended = true;
              }
            });
          });
        } catch (error) {
          {
            triggers.forEach(trigger => {
              trigger.remove();
            });
          }
        }
      });
      return () => {};
    };

    var cappasity$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: cappasity
    });

})();
